import { Loader } from '@progress/kendo-react-indicators'
import React from 'react'
import RulesPage from '../rules/Rules'
import "./LoadingApp.scss"
const LoadingApp = () => {
  return (
    // <div className="body" style={{ "height": "100vh", "display": "flex", "justifyContent": "center", "alignItems": "center" }}>
    <div>
      <Loader type="infinite-spinner" size="large" className="center-spinner" />
      <div className="disable-clicks">
        <RulesPage />
      </div>
    </div>
    // </div>
  )
}

export default LoadingApp